import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { Helper } from '@usimweb/core/services';

@Component({
    selector: 'app-parameters',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './parameters.component.html',
    styleUrls: ['./parameters.component.scss'],
    standalone: false
})
export class ParametersComponent implements OnInit, OnChanges {
  @Input() project_uuid!: string;

  @Input() versions: string[] = [];

  @Input() parameters: any;

  @Input() titles: string[] = [];

  private parameterListReset = [] as any;

  public compareList = [] as any;

  constructor() {}

  ngOnInit(): void {
    this.readParameters();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.parameters && changes['parameters']) {
      this.compareList = [];
      this.parameterListReset = [];
      this.readParameters();
    }
  }

  private readParameters() {
    for (const [keyTitle, value] of Object.entries(this.parameters[0])) {
      const dict = {
        group: keyTitle.toUpperCase().replace('_', ' '),
        values: null,
      };
      const values = [];

      let itemIndex = 0;
      for (const [key, value] of Object.entries(this.parameters[0][keyTitle])) {
        let compareDict = {
          key: Helper.StringFormatter.capitalizeFirstLetter(key),
          compareValues: [] as any,
        };

        for (let i = 0; i < this.parameters.length; i++) {
          const compareValue = Object.entries(this.parameters[i][keyTitle]);
          compareDict.compareValues.push(compareValue[itemIndex][1]);
        }

        values.push(compareDict);
        itemIndex++;
      }

      dict.values = values as any;
      this.compareList.push(dict);
    }

    this.parameterListReset = this.compareList;
  }

  public resetTable() {
    this.compareList = this.parameterListReset;
  }

  public openResult(index: number) {
    const url = '/#/app/result' + '/' + this.project_uuid + '/' + this.versions[index];
    window.open(url, '_blank');
  }
}
